export function sumirDepoisTempo(setadorModais: any) {
  setTimeout(() => {
    setadorModais(null);
  }, 3000);
}
